export const breakPoint = {
  tablet: '(max-width:768px)',
  mobile: '(max-width:600px)'
};
